<template>
  <div>
<!--    <div-->
<!--      class="uppercase text-lightblue  tracking-wider mt-6 font-open-sans text-3xl"-->
<!--    >-->
<!--      Date-->
<!--    </div>-->
<!--    <div-->
<!--      class="mt-4 flex items-center justify-center text-3xl leading-none font-extrabold text-gray-900"-->
<!--    >-->
<!--      <span>{{ sessionDate }}</span>-->
<!--    </div>-->
<!--    <div-->
<!--      class="uppercase text-lightblue  tracking-wider mt-6 font-open-sans text-3xl"-->
<!--    >-->
<!--      Time-->
<!--    </div>-->
<!--    <div-->
<!--      class="mt-4 flex items-center justify-center text-3xl leading-none font-extrabold text-gray-900"-->
<!--    >-->
<!--      <span> {{ friendlyStart }} - {{ friendlyEnd }} </span>-->
<!--    </div>-->
    <div>
      <speaker-side-bar
        v-for="(speaker,idx) in session.speakers"
        :speaker="speaker"
        :key="idx"
      ></speaker-side-bar>
    </div>
  </div>
</template>

<script>
import SpeakerSideBar from "./SpeakerSideBar";
import { toFriendlyDate, toFriendlyTime } from "../utils/dateHelpers";

export default {
  name: "DetailsSideBar",
  components: { SpeakerSideBar },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    friendlyStart() {
      return toFriendlyTime(this.session.startTime);
    },
    friendlyEnd() {
      return toFriendlyTime(this.session.endTime);
    },
    sessionDate() {
      return toFriendlyDate(this.session.startTime);
    }
  }
};
</script>

<style scoped></style>
